import React from 'react';
import './CookieBanner.css';

const STORAGE_KEY = "GDPR_COOKIE_v1"

const getStorage = () => {
  let persistentStorage;
  try {
    persistentStorage = window.localStorage;
  } catch (e) {
    // Something went wrong, we can't use localStorage
    persistentStorage = null;
  }
  return persistentStorage;
};

export class CookieBanner extends React.Component {

  constructor (props) {
    super(props);

    // const persistentStorage = getStorage();
    this.state = {
      // consent: !!persistentStorage ? !!persistentStorage.getItem(STORAGE_KEY) : false
      consent: true
    };
  }

  giveConsent = () => {
    const persistentStorage = getStorage();
    if (!!persistentStorage) {
      persistentStorage.setItem(STORAGE_KEY, true);
    }

    this.setState({ consent: true });
  }

  onCloseClicked = () => {
    this.giveConsent();
  };

  render () {
    if (!!this.state.consent) {
      // Consent is given, no banner
      return null;
    }

    return (
      <div className="gdpr-mah-cookies d-print-none">
        <span className="gdpr-text">
          We use cookies to offer you a better browsing experience, analyze the site traffic and personalize content.
          Read about how we use cookies and how you can control them in our&nbsp;
          <a target="_blank" rel="noopener noreferrer" href="https://www.trypopin.com/popin-privacy-policy" className="gdpr-link">Cookie Policy</a>.
          If you continue to use this site, you consent to use our cookies.
        </span>
        <i className="material-icons clickable mr-3" style={ { fontColor: '#FFFFFF' }} onClick={ this.onCloseClicked }>close</i>
      </div>
    );
  }
}
